import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useProviderAccountsFilterFields } from './hooks/useProviderAccountsFilterFields';

export const ProviderAccountsListFilterChips: React.FC = () => {
  const fields = useProviderAccountsFilterFields();

  return <FilterChips fields={fields} />;
};
